export enum Level {
	Low = 0,
	Medium = 1,
	High = 2
}